module.exports = __webpack_public_path__ + "media/img/Vector-8bdca899500721ab65baa9b4f5c0cfff.png";